<template>
  <div>
    <div class="invoice_bill">
      <div class="invoice_bill——head">
        <div class="company"
             :class="{ active: isActive ==2  }"
             @click="infolist(2)">企业</div>
        <div class="company"
             :class="{ active: isActive ==1  }"
             @click="infolist(1)">个人</div>
      </div>
      <div class="invoice_bill_add"
           @click="addhead()">
        新增发票抬头
      </div>
    </div>
    <div class="debit_list">
      <el-card v-for="(item,index) in this.infoList "
               :key='index'
               class="m21">
        <div class="box-card"
             @click="seeDetals(item)">
          <div style="width:100%">
            <div class="flex">
              <div class="invoice_gsname">{{item.header}}</div>
            </div>
            <div class="dutyparagraph m20 flexs">
              <div style="cursor:pointer">发票类型:{{item.invoice_type=="1"?"增值税普通发票" :"增值税专用发票"}}</div>

            </div>

          </div>
        </div>
      </el-card>
    </div>
    <div class="invoice_foot">
      <!-- <div class="invoice_confirm">确定</div> -->
      <!-- <div class="invioce_cancle"
           @click="quxiao()">取消</div> -->
    </div>

    <!-- 添加抬头 -->
    <div>
      <el-dialog title="新增发票抬头"
                 append-to-body
                 width="468px"
                 :before-close="handleClose"
                 :visible.sync="addheaderVisible">
        <addHeader :data="this.isActive"
                   @close="close"
                   @invoiceList="invoiceList"
                   v-if="addheaderVisible"></addHeader>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import addHeader from './addHeader'
export default {
  components: {
    addHeader
  },
  data() {
    return {
      isActive: 2,
      infoList: [],
      event: 2,
      addheaderVisible: false
    }
  },
  created() {},
  mounted() {
    this.invoiceList(this.event)
  },
  methods: {
    // 默认初次回显企业发票列表
    invoiceList(event) {
      this.$api
        .qycgInvoice({
          type: event,
          shop_type: 'qycg'
        })
        .then(res => {
          if (res.code == 0) {
            if (res.data.list) {
              this.infoList = res.data.list
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
            // console.log(res)
          }
        })
    },
    // 切换发票类型
    infolist(i) {
      this.isActive = i
      this.invoiceList(i)
    },
    //打开新增抬头，关闭发票信息
    addhead() {
      this.addheaderVisible = true
      this.$emit('closeA', '')
    },
    //关闭新增抬头，打开发票信息
    retureInfo(i) {
      this.$emit('someInvoice', i)
      // this.invoiceList(i)
    },
    // 发票抬头的X
    handleClose() {
      this.addheaderVisible = false
      this.$emit('someInvoice')
    },
    close(i) {
      this.addheaderVisible = false
      this.retureInfo(i)
      this.infolist(i)
    },
    // 默认发票
    seeDetals(i) {
      this.$api
        .defaultInvoice({
          shop_type: 'qycg',
          id: i.id
        })
        .then(res => {
          if (res.code == 0) {
            this.$emit('closeA', i)
          } else {
            this.$message({
              type: 'warning',
              message: res.msg
            })
          }
        })
    },
    quxiao() {
      this.$emit('closeA', '')
    }
  }
}
</script>
<style lang="scss" >
.invoice_bill {
  margin-top: -17px;
  // padding: 0 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .invoice_bill——head {
    display: flex;
    align-items: center;
    .company {
      width: 72px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f5f5f5;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333;
      cursor: pointer;
    }
    .active {
      background: #ffdfe2;
      border: 1px solid #ff0e25;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ff0e25;
    }
  }
  .invoice_bill_add {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #0e9cff;
    line-height: 12px;
    cursor: pointer;
  }
}

.debit_list {
  // padding: 0 32px;
  overflow-y: scroll;
  height: 350px;
  margin-top: 16px;

  .box-card {
    display: flex;
  }
  .m21 {
    margin-top: 16px;
    .el-card__body {
      padding: 12px !important;
    }
    .flex {
      display: flex;
      align-items: center;
      .invoice_gsname {
        cursor: pointer;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333;
      }
    }
    .m20 {
      margin-top: 17px;
    }
    .dutyparagraph {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666;
    }
    .flexs {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .f12 {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #0e9cff;
      margin-left: 24px;
    }
  }
}
.invoice_foot {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  .invioce_cancle {
    width: 108px;
    height: 32px;
    background: #fff;
    border-radius: 2px;
    border: 1px solid #ebebeb;
    margin-left: 8px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .invoice_confirm {
    margin-left: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 108px;
    height: 32px;
    background: #ff0e25;
    border-radius: 2px;
    font-size: 12px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #fff;
  }
}
.el-dialog__header {
  width: 468px !important;
  padding: 9px 18px !important;
  box-sizing: border-box;
  background-color: #ebebeb !important;
}
.el-dialog__title {
  font-size: 16px !important;
}
.el-dialog__headerbtn {
  top: 11px !important;
  right: 12px !important;
  font-size: inherit !important;
}
</style>
